module.exports = __webpack_public_path__ + "images/7e5b50ab06edec76d459c6854e859df1-IMG_5662.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/slides/living2/IMG_5662.jpg
// module id = ./src/assets/images/slides/living2/IMG_5662.jpg
// module chunks = 0